import { analysisConstants as constants } from '../constants';
import { helper } from '../helpers/helper';

const initialState = {
    id: "",
    portfolioAnalyses: {},
    filter: {
        contractTypes: [],
        conceptGroups: [],
        concepts: {},
        periods: {},
        governingLaws: []
    },
    exceptions: [],
    isLoading: [],
    shouldRefreshAnalysis: false
};

export const analysis = (state, action) => {
    state = state || initialState;

    // SELECT & DESELECT ANALYSIS
    if (action.type === constants.SELECT_PORTFOLIO_ANALYSIS) {
        return {
            ...state,
            id: action.id
        }
    }

    if (action.type === constants.DESELECT_PORTFOLIO_ANALYSIS) {
        return {
            ...state,
            id: ""
        }
    }

    // LIST ANALYSES
    if (action.type === constants.GET_PORTFOLIO_ANALYSES_LIST_REQUEST) {
        return {
            ...state,
            portfolioAnalyses: {},
            isLoading: [...state.isLoading, constants.GET_PORTFOLIO_ANALYSES_LIST_REQUEST]
        };
    }
    if (action.type === constants.GET_PORTFOLIO_ANALYSES_LIST_SUCCESS) {
        let analyses = {};
        action.analyses.forEach(a => analyses[a.id] = { ...a, concepts: a.categories });

        return {
            ...state,
            portfolioAnalyses: analyses,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_PORTFOLIO_ANALYSES_LIST_REQUEST)
        };
    }
    if (action.type === constants.GET_PORTFOLIO_ANALYSES_LIST_FAILURE) {
        return {
            ...state,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_PORTFOLIO_ANALYSES_LIST_REQUEST),
            exceptions: action.exceptions
        };
    }

    // GET PORTFOLIO ANALYSIS
    if (action.type === constants.GET_PORTFOLIO_ANALYSIS_REQUEST) {

        let analysis = state.portfolioAnalyses[action.id];
        let isAlreadyWaiting = state.isLoading.includes(constants.GET_PORTFOLIO_ANALYSIS_REQUEST);
        return {
            ...state,
            id: action.id,
            portfolioAnalyses: {
                ...state.portfolioAnalyses,
                [action.id]: {
                    ...analysis,
                    id: action.id,
                    name: analysis ? analysis.name : "",
                    description: analysis ? analysis.description : "",
                    documentIds: analysis ? analysis.documentIds : [],
                    documentAnalysisIds: analysis ? analysis.documentAnalysisIds : [],
                    documentAnalyses: analysis ? analysis.documentAnalyses : [],
                    contractTypes: analysis ? analysis.contractTypes : [],
                    insights: analysis ? analysis.insights : [],
                    concepts: analysis ? analysis.concepts : [],
                    themePackageId: analysis ? analysis.themePackageId : "",
                    themePackageName: analysis ? analysis.themePackageName : "",
                    wasSaved: analysis ? analysis.wasSaved : "",
                    userId: analysis ? analysis.userId : "",

                }
            },
            isLoading: isAlreadyWaiting ? state.isLoading.slice() : [...state.isLoading, constants.GET_DOCUMENT_ANALYSIS_REQUEST],
            shouldRefreshAnalysis: false
        };
    }

    if (action.type === constants.GET_PORTFOLIO_ANALYSIS_SUCCESS) {
        return {
            ...state,
            id: action.id,
            portfolioAnalyses: {
                ...state.portfolioAnalyses,
                [action.id]: {
                    id: action.id,
                    name: action.name,
                    description: action.description,
                    documentIds: action.documentIds,
                    documentAnalysisIds: action.documentAnalysisIds,
                    documentAnalyses: action.documentAnalyses,
                    contractTypes: action.contractTypes,
                    insights: action.insights,
                    concepts: action.categories,
                    themePackageId: action.themePackageId,
                    themePackageName: action.themePackageName,
                    wasSaved: action.wasSaved,
                    userId: action.userId
                }
            },
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_PORTFOLIO_ANALYSIS_REQUEST),
            shouldRefreshAnalysis: false
        };
    }

    if (action.type === constants.GET_PORTFOLIO_ANALYSIS_PENDING) {
        return {
            ...state,
            shouldRefreshAnalysis: true,
            refreshAnalysisDelay: 3
        };
    }

    if (action.type === constants.GET_PORTFOLIO_ANALYSIS_FAILURE) {
        return {
            ...state,
            exceptions: [...state.exceptions, action.exception],
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_PORTFOLIO_ANALYSIS_REQUEST),
            shouldRefreshAnalysis: false,
            refreshAnalysisDelay: 0
        };
    }

    // FILTER ANALYSIS
    if (action.type === constants.CHANGE_ANALYSIS_FILTER) {
        return {
            ...state,
            filter: action.filter
        };
    }

    // DELETE ANALYSIS
    if (action.type === constants.DELETE_PORTFOLIO_ANALYSIS_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.DELETE_PORTFOLIO_ANALYSIS_REQUEST]
        };
    }
    if (action.type === constants.DELETE_PORTFOLIO_ANALYSIS_SUCCESS) {
        const analyses = Object.assign({}, state.portfolioAnalyses);
        delete analyses[action.id];

        return {
            ...state,
            portfolioAnalyses: analyses,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_PORTFOLIO_ANALYSES_LIST_REQUEST)
        };
    }
    if (action.type === constants.DELETE_PORTFOLIO_ANALYSIS_FAILURE) {
        return {
            ...state,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.GET_PORTFOLIO_ANALYSES_LIST_REQUEST),
            exceptions: action.exceptions
        };
    }

    // EXPORT TO EXCEL
    if (action.type === constants.EXPORT_PORTFOLIO_ANALYSIS_REQUEST) {
        return {
            ...state,
            isLoading: [...state.isLoading, constants.EXPORT_PORTFOLIO_ANALYSIS_REQUEST]
        };
    }

    if (action.type === constants.EXPORT_PORTFOLIO_ANALYSIS_SUCCESS) {
        return {
            ...state,
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.EXPORT_PORTFOLIO_ANALYSIS_REQUEST)
        };
    }

    if (action.type === constants.EXPORT_PORTFOLIO_ANALYSIS_FAILURE) {
        return {
            ...state,
            exceptions: [...state.exceptions, action.exception],
            isLoading: helper.removeFirstElement(state.isLoading.slice(), constants.EXPORT_PORTFOLIO_ANALYSIS_REQUEST)
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/analysis.reducer.js